(() => {
  const root = document.querySelector('.mm-course-page');
  if (!root) return;

  /* Mobile menu */
  root.querySelectorAll('[data-mm-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = root.querySelector('[data-mm-mobile-nav]');
      if (!panel) return;
      const open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  root.querySelectorAll('[data-mm-mobile-nav] a').forEach((link) => {
    link.addEventListener('click', () => {
      const panel = root.querySelector('[data-mm-mobile-nav]');
      const btn = root.querySelector('[data-mm-menu-toggle]');
      if (panel) panel.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  });

  /* FAQ accordion */
  root.querySelectorAll('[data-mm-faq-item]').forEach((item) => {
    const btn = item.querySelector('[data-mm-faq-toggle]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const willOpen = !item.classList.contains('is-open');
      const list = item.closest('[data-mm-faq-list]');
      if (list) {
        list.querySelectorAll('[data-mm-faq-item].is-open').forEach((openItem) => {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            const openBtn = openItem.querySelector('[data-mm-faq-toggle]');
            const icon = openItem.querySelector('[data-mm-faq-icon]');
            if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
            if (icon) icon.textContent = '+';
          }
        });
      }
      item.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      const icon = item.querySelector('[data-mm-faq-icon]');
      if (icon) icon.textContent = willOpen ? '−' : '+';
    });
  });

  /* Video players */
  root.querySelectorAll('[data-mm-video]').forEach((frame) => {
    const playBtn = frame.querySelector('[data-mm-video-play]');
    const video = frame.querySelector('video');
    if (!playBtn || !video) return;

    playBtn.addEventListener('click', () => {
      frame.classList.add('is-playing');
      video.controls = true;
      video.play().catch(() => {});
    });
  });

  /* Sticky mobile CTA — hide near pricing or footer */
  const sticky = root.querySelector('[data-mm-sticky-cta]');
  const pricing = root.querySelector('#booking, [data-mm-pricing]');
  const footer = root.querySelector('[data-mm-footer]');

  if (sticky && 'IntersectionObserver' in window) {
    const syncSticky = () => {
      const hide =
        (pricing && pricing.__mmVisible) || (footer && footer.__mmVisible);
      sticky.classList.toggle('is-visible', !hide && window.innerWidth < 860);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.__mmVisible = entry.isIntersecting;
        });
        syncSticky();
      },
      { threshold: 0.1 }
    );

    if (pricing) observer.observe(pricing);
    if (footer) observer.observe(footer);

    window.addEventListener('resize', syncSticky);
    syncSticky();
  } else if (sticky) {
    const sync = () => {
      sticky.classList.toggle('is-visible', window.innerWidth < 860);
    };
    window.addEventListener('resize', sync);
    sync();
  }
})();
